export const IMAGE_CONFIG = {
  type: 'image',
  mblimit: Infinity,
  uploadPreset: 'AutomaticResize1600x1600',
  types: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg+xml'],
  extensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg']
};

export const VIDEO_CONFIG = {
  type: 'video',
  uploadPreset: 'unsigned',
  // Defined in the Cloudinary console of every account we upload to.
  optimizedUploadPreset: 'video-optimized',
  types: [
    'mp4',
    'quicktime',
    'webm',
    'ogg',
    '3gpp',
    '3gpp2',
    'x-ms-wmv',
    'mpeg',
    'x-flv',
    'x-mkv',
    'x-matroska',
    'x-msvideo'
  ],
  extensions: ['mp4', 'mov', 'webm', 'ogv', '3gp', '3g2', 'wmv', 'mpeg', 'flv', 'mkv', 'avi']
};

export const PDF_CONFIG = {
  type: 'pdf',
  mbLimit: 50,
  uploadPreset: 'unsigned',
  types: ['pdf', 'application'],
  extensions: ['pdf']
};

export const EAGER_CACHE = {
  video: [
    {
      quality: 90,
      audio_codec: 'none'
    }
  ],
  image: []
};

export const OPTIMIZED_VIDEO_DELIVERY_OPTIONS = ['vc_h264', 'q_auto:good', 'c_limit', 'w_1920', 'h_1920'];

export const DIRTY_VIDEO_EXTENSIONS = ['webm', 'ogv', '3gp', '3g2', 'wmv', 'mpeg', 'flv', 'mkv', 'avi', 'mov'];
